













import { Vue, Component } from "vue-property-decorator";
import FscPageHeader from "@/components/FscPageHeader.vue";
import VerticalDivider from "@/components/VerticalDivider.vue";
import TestingOrganizationsStudentTable from "@/views/Exam/TestingOrganizations/TestingOrganizationsStudentTable.vue";

@Component({
  components: {
    TestingOrganizationsStudentTable,
    VerticalDivider,
    FscPageHeader,
  },
})
export default class TestingOrganizations extends Vue {
  public name = "TestingOrganizations";
}
